import {
    Box,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Button,
    Input,
    useToast,
    Table, Thead, Tbody, Tr, Th, Td, Text,
    HStack,
    FormLabel,
    Select,
    useColorModeValue,
  } from "@chakra-ui/react";
  import React, { useState, useEffect } from "react";
  import { FiEdit, FiCheck, FiX } from "react-icons/fi";
  import axios from "axios";
  import { BatchClass, Term } from "../Common/types";
  import { Tooltip } from "@chakra-ui/react";
  import { toUtcISOString, parseUtc, fmtLocal, utcToInputValue,inputValueToUtc,toBackendISO } from "../../utils/dates";
  
  
  interface BatchTermClassesProps {
    batch_id: number;
    course_id: number;
  }
  
  const BatchTermClasses: React.FC<BatchTermClassesProps> = ({batch_id,course_id,}) => {

    const [terms, setTerms] = useState<Term[]>([]);
    const [selectedDates, setSelectedDates] = useState<{ [key: number]: string }>({});

    const [batchClassesForSelectedTerm, setBatchClassesForSelectedTerm] = useState<BatchClass[]>([]);
    const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited
  
    const toast = useToast();

    const [selectedTermId, setSelectedTermId] = useState<number | null>(null);

    const buttonBg1 = useColorModeValue(
        'linear-gradient(to right, cyan.50, cyan.100)',
        'linear-gradient(to right, cyan.600, cyan.700)'
      );

      const buttonHoverBg1 = useColorModeValue(
        'cyan.200',
        'cyan.500'
      );
      const tableHeaderBg = useColorModeValue("teal.100", "teal.700");
  
    console.log("Batch Id and Course ID", batch_id, course_id);
  
    const fetchTerms = async () => {
      try {
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const response = await axios.get(apiurl + `/courses/${course_id}/terms`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setTerms(response.data);
        console.log("Terms for the batch", response.data);
      } catch (error) {
        console.error("Failed to load terms of the course", error);
      }
    };
  
    const handleDateChange = (termId: number, value: string) => {
      setSelectedDates((prev) => ({
        ...prev,
        [termId]: value,
      }));
    };


    /** Convert every date-ish field of an ActualClass row to Date */
    const normaliseActualClasses = (arr: BatchClass[]) =>
      arr.map(c => ({
        ...c,
        start_time: parseUtc(c.start_time),   // string → Date
        end_time:   parseUtc(c.end_time),
      }));

    const fetchSelectedTermClasses = async (termId: number) => {
        try {

         console.log("Selected Term's Batch Classes to be fetched for term :", termId);
          const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
    
          const response = await axios.get(apiurl + `/batches/${batch_id}/classes`, {
            params: { term_id: termId }, // Add batch_id as a query parameter
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          setBatchClassesForSelectedTerm(normaliseActualClasses(response.data));
        
          console.log("Actual Batch Classes for the batch", response.data);
        } catch (error) {
          console.error("Failed to load classes", error);
          
        }
      };
  
    const handleGenerateClasses = async (termId: number) => {
      if (!selectedDates[termId]) {
        toast({
          title: "Date Required",
          description: "Please select a start date before generating classes.",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }
  
      try {
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const payload = {
            term_id: termId, // Match the key expected by the backend
            term_start_date: selectedDates[termId], // Ensure ISO format
          };
  
        const response =await axios.post(apiurl + `/batches/${batch_id}/create-classes`, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        setBatchClassesForSelectedTerm(normaliseActualClasses(response.data));
  
        toast({
          title: "Success",
          description: `Classes for term #${termId} generated successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } catch (error) {
        console.error("Failed to generate classes", error);
        toast({
          title: "Error",
          description: "Failed to generate classes. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };


    const handleUpdateActualClass = async (batchClass: BatchClass, termId:number) => {
        if(batchClass.end_time < batchClass.start_time)
        {
            toast({ title: "Failed to update Batch Class, Set End Date Time Later than Start Date Time", status: "error" });
        }
        else
        {
            try {
        
            const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
            
            // console.log("Printing Token from Update" + localStorage.getItem("token"));
            // const response = await axios.put(apiurl+`/actual-classes/${batchClass.id}`, batchClass, {
            //     headers: {
            //     Authorization: `Bearer ${localStorage.getItem('token')}`
            //     }
            // });


              /* Build a payload where every Date → ISO string with trailing Z */
              const payload = {
                  ...batchClass,
                  start_time: toBackendISO(batchClass.start_time), // "YYYY-MM-DDTHH:mm:ss.SSS"
                  end_time:   toBackendISO(batchClass.end_time),
                };


              const { data } = await axios.put(
                `${apiurl}/actual-classes/${batchClass.id}`,
                payload,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              );
            fetchSelectedTermClasses(termId);
            setEditRow(null); // Reset edit mode after successful update
            toast({ title: "Batch Class updated successfully", status: "success" });
            } catch (error) {
            console.error("Failed to update Batch Class", error);
            toast({ title: "Failed to update Batch Class", status: "error" });
            }
        }
      };
    
      const handleEditRow = (batchclass_id: number) => {
        setEditRow(batchclass_id);
      };
    
      const handleCancelEdit = () => {
        setEditRow(null);
      };



    const handleAccordionChange = (expandedIndex: number | number[] | null) => {
        if (typeof expandedIndex === "number") {
          // Single index is open
          const selectedTerm = terms[expandedIndex];
          if (selectedTerm) {
            setSelectedTermId(selectedTerm.id);
          }
        } else {
          // No accordion items are open or multiple items are open
          setSelectedTermId(null);
        }
      };
  
    useEffect(() => {
      fetchTerms();
    }, [course_id]);

    useEffect(() => {
        if(selectedTermId)
        {
        fetchSelectedTermClasses(selectedTermId);
        }
      }, [selectedTermId]);


      // at top of the component (once)
      const [startDraftById, setStartDraftById] = React.useState<Record<number, string>>({});

      const handleStartChange = (id: number, raw: string) => {
        // always mirror what the user typed
        setStartDraftById(prev => ({ ...prev, [id]: raw }));

        // commit only if it's a valid datetime
        const d = new Date(raw);
        if (!Number.isNaN(d.getTime())) {
          setBatchClassesForSelectedTerm(prev =>
            prev.map(cls => (cls.id === id ? { ...cls, start_time: d } : cls))
          );
        }
      };

      const clearStartDraft = (id: number) => {
        setStartDraftById(prev => {
          const { [id]: _, ...rest } = prev;
          return rest;
        });
      };


      const [endDraftById, setEndDraftById] = React.useState<Record<number, string>>({});

      const handleEndChange = (id: number, raw: string) => {
        // always mirror what the user typed
        setEndDraftById(prev => ({ ...prev, [id]: raw }));

        // commit only if it's a valid datetime
        const d = new Date(raw);
        if (!Number.isNaN(d.getTime())) {
          setBatchClassesForSelectedTerm(prev =>
            prev.map(cls => (cls.id === id ? { ...cls, end_time: d } : cls))
          );
        }
      };

      const clearEndDraft = (id: number) => {
        setEndDraftById(prev => {
          const { [id]: _, ...rest } = prev;
          return rest;
        });
      };
  
    return (
      <Box >
        <Accordion allowToggle mt={1} onChange={handleAccordionChange} fontSize={"sm"}>
          {terms.map((term,index) => (
            <AccordionItem key={term.id} fontSize={"sm"}>
              <h2>
                <AccordionButton  height="40px"
                  backgroundImage={buttonBg1} // Use backgroundImage for gradients
                  _hover={{ bg: buttonHoverBg1 }}
                  borderRadius="sm"
                  mt={1}>
                  <Box flex="1" textAlign="left" fontSize="sm">
                    # {term.sequence_number} {term.title}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>

              </h2>
              <AccordionPanel p={0}>
                <Box
                  padding="4"
                  borderWidth="1px"
                  
                  borderRadius="sm"
                >
                    <HStack>
                    <FormLabel minWidth={250} fontSize={"sm"}>Start Date for Unsynched Classes</FormLabel>
                  <Input
                    type="date"
                    placeholder="Select Term Start Date"
                    size={"sm"}
                    onChange={(e) => handleDateChange(term.id, e.target.value)}
                    value={selectedDates[term.id] || ""}
                    mb={4}
                  />
                    </HStack>
                    
                  <Button
                    size={"sm"}
                    borderRadius={"sm"}
                    onClick={() => handleGenerateClasses(term.id)}
                    colorScheme="blue"
                  >
                    Generate Unsynched Classes
                  </Button>
                  </Box>
                  <Box border="1px solid #E2E8F0" borderRadius="sm" p={4} overflowX="auto" mt={2}>
                    <Text fontSize="xl" fontWeight="bold" mb={4}>
                        Batch Classes
                    </Text>
                    <Table variant="simple" size="sm">
                    <Thead bg={tableHeaderBg}>
                        <Tr>
                            <Th>ID</Th>  
                            <Th>Title</Th>
                            <Th>Description</Th>
                            <Th>Seq. Number</Th>
                            <Th>Start Time</Th>
                            <Th>End Time</Th>
                            <Th>Status</Th>
                            <Th>Actions</Th>
                        </Tr>
                        </Thead>
                        <Tbody>
                              {batchClassesForSelectedTerm.map((batchClass) => {
                                const bufferStart = startDraftById[batchClass.id] ?? utcToInputValue(batchClass.start_time);
                                const bufferEnd = endDraftById[batchClass.id] ?? utcToInputValue(batchClass.end_time);


                                return (
                                  <Tr key={batchClass.id}>
                                    <Td>{batchClass.id}</Td>
                                    <Td>{batchClass.title}</Td>
                                    <Td>{batchClass.description || "N/A"}</Td>
                                    <Td>{batchClass.sequence_number || "N/A"}</Td>

                                    <Td>
                                      {editRow === batchClass.id ? (
                                        <Input
                                          type="datetime-local"
                                          size="sm"
                                          step="60"
                                          value={bufferStart}
                                          onChange={(e) => handleStartChange(batchClass.id, e.target.value)}
                                          onBlur={() => clearStartDraft(batchClass.id)}  // snap back to canonical formatting
                                        />
                                      ) : (
                                        fmtLocal(batchClass.start_time)
                                      )}
                                    </Td>
                                <Td>

                                      {editRow === batchClass.id ? (
                                        <Input
                                          type="datetime-local"
                                          size="sm"
                                          step="60"
                                          value={bufferEnd}
                                          onChange={(e) => handleEndChange(batchClass.id, e.target.value)}
                                          onBlur={() => clearEndDraft(batchClass.id)}  // snap back to canonical formatting
                                        />
                                      ) : (
                                        fmtLocal(batchClass.end_time)
                                      )}
{/*                                     {editRow === batchClass.id ? (
                                         <Input
                                                type="datetime-local"
                                                size="sm"
                                                value={utcToInputValue(batchClass.end_time)}  
                                                onChange={e => {
                                                  // 1️⃣ take local clock value straight to a Date
                                                  const localDate = new Date(e.target.value);    // 11:00 local → 01:00 UTC internally

                                                  // 2️⃣ immutably replace this class inside the array
                                                  setBatchClassesForSelectedTerm(prev =>
                                                    prev.map(cls =>
                                                      cls.id === batchClass.id ? { ...cls, end_time: localDate } : cls
                                                    )
                                                  );
                                                }}
                                              />
                                    ) : (
                                      fmtLocal(batchClass.end_time)                     //  ← read-only view
                                    )} */}
                                  </Td>
                                


                        {/* Editable Status */}
                          <Td>
                            {editRow === batchClass.id ? (
                              <Select
                                value={batchClass.status}
                                size={"sm"}
                                onChange={(e) => {
                                    batchClass.status = e.target.value;
                                    setBatchClassesForSelectedTerm([...batchClassesForSelectedTerm]);
                                    }}
                              >
                                <option value="Scheduled">Scheduled</option>
                                <option value="Cancelled">Cancelled</option>
                              </Select>
                            ) : (
                              batchClass.status || "N/A"
                            )}
                          </Td>

                            <Td>
                                {editRow === batchClass.id ? (
                                <>
                                    <Tooltip label="Update">
                                    <Button size="sm" onClick={() => handleUpdateActualClass(batchClass, term.id)}>
                                        <FiCheck />
                                    </Button>
                                    </Tooltip>
                                    <Tooltip label="Cancel">
                                    <Button size="sm" ml={2} onClick={handleCancelEdit}>
                                        <FiX />
                                    </Button>
                                    </Tooltip>
                                </>
                                ) : (
                                <Tooltip label="Edit">
                                    <Button size="sm" onClick={() => handleEditRow(batchClass.id)}>
                                    <FiEdit />
                                    </Button>
                                </Tooltip>
                                )}
                            </Td>
                            </Tr>
                          );
                          })}
                        </Tbody>
                    </Table>
                    </Box>

                
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    );
  };
  
  export default BatchTermClasses;
  